var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-back',
                        view: publicPath + 'sprite.svg#view-icon-back',
                        viewBox: '0 0 26 21',
                        title: 'Combined Shape',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };